/* global google */
import React, {Component} from 'react';
import styled from 'styled-components';
import media from '../MediaQueries.js';
import FontAwesome from 'react-fontawesome';
import PropTypes from 'prop-types';
import { Collapse, Input, InputGroup, InputGroupButton, FormFeedback, Navbar, NavbarToggler, NavbarBrand, Nav, NavItem,
        NavLink, Container, Row, Col, Jumbotron, Button, ButtonGroup, Dropdown, DropdownToggle } from 'reactstrap';
import { Link } from 'react-router-dom';

export default class OffersContent extends Component {

  constructor(props) {
    super(props);

  }

  render() {

    return (
    	<Container_s>
          <h2>Special Offers</h2>
          <h3>Check out our current deals and specials!</h3>
          <hr />
          <h4><b>1) Free 16oz jar candle coupon with $100 purchase!</b> {' '}
              <i>(at checkout, be sure to login and your purchases will be stored. You will be able to review your order history
                 and track as you near $100. We will periodically (every 30 days or less) review all $100 increments spent
                 by you & be in touch about your free candle. {/*send a free 16oz candle redeemable code for each to the email you were signed into the cart as. 
                 This code can be used at a future checkout.*/})</i>
          </h4>
          {/*
          <h4><b>2) Free shipping if in-person pickup chosen!</b> {' '}
              <i>(can be chosen at checkout -- you must pick up <a target="_blank" style={{color: "#76451F", fontWeight: "bold"}}
                href="https://www.google.com/maps/place/93+Germania+St,+Galeton,+PA+16922/@41.7319753,-77.6506319,17z/data=!3m1!4b1!4m5!3m4!1s0x89ce19f9457092e1:0xe0b43148ccbcf991!8m2!3d41.731971!4d-77.648443">
                 here.</a>)</i>
          </h4>
        */}
          <hr />
        </Container_s>
		);
	}
}

const Container_s = styled(Container)`
  padding: 10px 15px 0 15px!important;

  h2,h3 {
    color: #76451F;
    font-size: 36px;
    font-weight: bold;
    text-align: center;
    margin: 10px 15px 10px 15px;
  }
  h3 {
    color: black;
    font-size: 15px;
    ${media.lg` font-size: 17px; `}
    margin-bottom: 20px;
  }
  h4 {
    color: black;
    font-size: 15px;
    font-family: "Raleway";
    ${media.lg` font-size: 17px; `}
    margin-bottom: 20px;
    text-align: left;
  }
  hr {
    border-top: 1px solid #8A572A;
  }
`;




// WEBPACK FOOTER //
// ./src/components/OffersContent.js